import {
  Button,
  Checkbox,
  Inline,
  Modal,
  type ModalProps,
  Notification,
  Stack,
  Typography,
} from '@omnipresentgroup/design-system';
import { useState } from 'react';

export const MODAL_TITLE =
  'Are you sure you haven’t made the bank transfer yet?';
export const MODAL_DESCRIPTION = `If you've already done the transfer, there's nothing else you need to do. \n We'll let you know as soon as the transfer arrives and the payment to the contractors(s) is made.`;
export const NOFITICATION_TITLE =
  'This invoice was part of a transaction to pay multiple invoices';

type Props = {
  modalProps: Omit<ModalProps, 'children'>;
  handleCancel: (event: React.SyntheticEvent) => void;
  handleSubmit: (event: React.SyntheticEvent) => void;
  loading?: boolean;
  isBulkPayment?: boolean;
};

export const ExpiredPaymentModal = ({
  modalProps,
  handleCancel,
  handleSubmit,
  loading,
  isBulkPayment,
}: Props) => {
  const [noTransferCheck, setNoTransferChecked] = useState<boolean>(false);

  return (
    <Modal {...modalProps} span={6}>
      <Modal.Header title={MODAL_TITLE} />

      <Modal.Body>
        <Stack gap="24">
          {isBulkPayment && (
            <Notification
              id={'transaction-notification'}
              title={NOFITICATION_TITLE}
            />
          )}
          <Typography as="span" size="14">
            {MODAL_DESCRIPTION}
          </Typography>
          <Checkbox
            id="no-money-check"
            label="I am sure that no money has been sent for this invoice/transaction"
            checked={noTransferCheck}
            onCheckedChange={() =>
              setNoTransferChecked((previousChecked) => !previousChecked)
            }
          />
        </Stack>
      </Modal.Body>

      <Modal.Footer>
        <Inline justify="space-between" w="stretch">
          <Button variant="secondary" onClick={handleCancel} loading={loading}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleSubmit}
            disabled={loading || !noTransferCheck}
          >
            Yes
          </Button>
        </Inline>
      </Modal.Footer>
    </Modal>
  );
};
